import { Injectable } from '@angular/core'
import { isValid } from 'date-fns'
import { MessageService } from '@services/message/message.service'
import { TStorageMessage } from '@ttypes/t-storage-message'
import { TStorageType } from '@ttypes/t-storage-type'

@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly VALID_DATE_PREFIX = 'valid~date~'

  // TODO: prefix setItem and getItem key with uid

  constructor(private messageService: MessageService) {}

  setItem(key: string, value: any, message: TStorageMessage = null, type: TStorageType = 'local') {
    const storage = this.getStorage(type)
    if (value instanceof Date && isValid(value)) value = `${this.VALID_DATE_PREFIX}${value}`
    storage.setItem(key, JSON.stringify(value))
    this.sendMessage(key, value, message)
  }

  getItem(key: string, defaultValue: any = null, message: TStorageMessage = null, type: TStorageType = 'local'): any {
    const storage = this.getStorage(type)
    const raw: string = storage.getItem(key)
    let ret: any
    if (raw != null) {
      ret = JSON.parse(raw)
      if (typeof ret === 'string' && ret.startsWith(this.VALID_DATE_PREFIX)) ret = new Date(ret.replace(this.VALID_DATE_PREFIX, ''))
    } else {
      ret = defaultValue
    }
    this.sendMessage(key, ret, message)
    return ret
  }

  // noinspection JSUnusedGlobalSymbols
  removeItem(key: string, type: TStorageType = 'local') {
    const storage = this.getStorage(type)
    storage.removeItem(key)
  }

  // PRIVATE METHODS

  private getStorage(type: TStorageType): Storage {
    return type === 'local' ? localStorage : sessionStorage
  }

  private sendMessage(name: string, payload: any, message: TStorageMessage = null) {
    if (message === 'message') this.messageService.send(name, this.constructor.name, payload)
    else if (message === 'messageReplay') this.messageService.sendReplay(name, this.constructor.name, payload)
  }
}
